import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BackendConfiguration} from '@application/configuration/backend-configuration';
import {StatusBarTarget} from '@domain/textile-data/status-bar-target.constants';
import {GridModel, StatusBar} from '@vdw/angular-component-library';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class HttpStatusBarService {
  private httpClient: HttpClient;
  private backendConfiguration: BackendConfiguration;

  public constructor(httpClient: HttpClient, backendConfiguration: BackendConfiguration) {
    this.httpClient = httpClient;
    this.backendConfiguration = backendConfiguration;
  }

  public getStatusBarData(statusBarTarget: StatusBarTarget, gridModel: GridModel): Observable<StatusBar> {
    return this.httpClient.post(`${this.backendConfiguration.getEndpoint()}${statusBarTarget}/status-bar-data`, gridModel.toJSON()).pipe(
      map((statusBarJSON: any) => {
        return StatusBar.fromJSON(statusBarJSON);
      })
    );
  }
}
